import { Stack, Typography } from '@mui/material'

interface NavigationHeaderProps {
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  text: string | null
}

export const NavigationHeader = ({
  leftIcon,
  rightIcon,
  text
}: NavigationHeaderProps) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      px={2}
      mt={2}
      mb={1.5}
      height={41}
      width="100%"
      justifyContent="space-between"
    >
      {leftIcon && leftIcon}
      <Typography variant="body1" fontWeight={700}>
        {text}
      </Typography>
      {rightIcon && rightIcon}
    </Stack>
  )
}
